export const AMOUNT_OPERATORS = {
  1: '=',
  2: '>',
  3: '<',
};
